module.exports = __webpack_public_path__ + "assets/img/teacher (17).f0569961.png";